import { app } from "../config/const"
import { encryptData,decryptData } from "./securityService"

let base = "/api"
if(process.env.REACT_APP_API_URL){
  base = process.env.REACT_APP_API_URL
}
const frontKey = localStorage.getItem('frontKey')

/**
 * Fetch data from services
 * @param url 
 * @param data 
 * @param key public server key
 * @returns 
 */
async function post(url:any,key:string|null,data:any={}){
  data.origin = window.location.protocol + '//' + window.location.host + window.location.pathname
  data.app = app.Sales
  const bodyData = key ? await encryptData(data,key) : {data:{origin:data.origin,app:app.Sales},key: frontKey}
  const config:RequestInit = {
    method: 'POST',
    body: JSON.stringify(bodyData),
    credentials: "same-origin",
    headers: {
      "Content-Type": "application/json",
    }
  }
  const res = await fetch(base + url,config)
  if(res.status === 240){
    throw { status: 240, message: "Token Expired" }
  }
  const encryptedData = await res.json();
  if(!encryptedData.key){
    return encryptedData
  }
  return decryptData(encryptedData)
}
const fetchDataService = {post}
export default fetchDataService